export default (store) => ({
  store,
  dispatch: store.dispatch,
});
